import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Modal from '../../../../common/modal'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import * as mdt from '../../../../common/modaltypes'
import FileInput from '../../../../common/fileInput'
import { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';

const PIckUpAndDropoffModalKgKm = ({ data, updateModal }) => {
  const theme = useTheme()
  const [fileData,setFileData]=useState(null)
  const { loginData, isUpdate, headText, branchAndCityOpt } = data
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

    useEffect(() => {
      const readExcelOrCSV = () => {
        if (!fileData) {
          console.log('No file selected.')
          return
        }
  
        const reader = new FileReader();

        reader.onload = (e) => {
          const arrayBuffer = e.target.result;
          const workbook = XLSX.read(arrayBuffer, { type: 'array' });
  
          // Assuming there is only one sheet in the Excel file
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
  
          // Convert the sheet data to JSON
          const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  
          // Display the content on the console
          const nonEmptyRows = data.filter(row => row.some(cell => cell !== undefined && cell !== null && cell !== ''));
        
        // Display the content on the console
        console.log('Excel File Content:', nonEmptyRows);
        };
  
        reader.readAsArrayBuffer(fileData);

      };
  
      // Call the function when fileData changes
      readExcelOrCSV();
    }, [fileData]);
  
  
const tableHeader = [
    { headerName: 'SN', field: "", headerSx: { minWidth: "20px", textAlign: 'right' }, showfilter: false },
    { headerName: 'Charge \nType id', field: "ChargeTypeName", headerSx: { minWidth: "90px", textAlign: 'right' }, showfilter: true },
    { headerName: 'Range Per \nKg Min.', field: "RangeMin", headerSx: { minWidth: "84px",textAlign: 'right'  }, showfilter: true },
    { headerName: 'Range Per \nKg Max.', field: "RangeMax", headerSx: { minWidth: "106px" ,textAlign: 'right' }, showfilter: true },
    { headerName: 'Range Per \nKm Min.', field: "RangeMin", headerSx: { minWidth: "84px", textAlign: 'right' }, showfilter: true },
    { headerName: 'Range Per \nKm Max.', field: "RangeMax", headerSx: { minWidth: "106px" ,textAlign: 'right' }, showfilter: true },
    { headerName: 'Charge \nPer Kg', field: "Charge", headerSx: { minWidth: "84px",textAlign: 'right'  }, showfilter: true },
    { headerName: 'Add. Chrg. \nPer Unit', field: "Charge", headerSx: { minWidth: "84px" ,textAlign: 'right' }, showfilter: true },
]
const tableDataDummy = [
    {ChargeId:4,RangeMin:10,RangeMax:20,Charge:10,RangeMinkm:1,RangeMaxkm:10,Chargeunit:5},
    {ChargeId:5,RangeMin:10,RangeMax:20,Charge:9,RangeMinkm:10,RangeMaxkm:20,Chargeunit:5},
    {ChargeId:1,RangeMin:10,RangeMax:20,Charge:8,RangeMinkm:20,RangeMaxkm:30,Chargeunit:5},
    {ChargeId:3,RangeMin:10,RangeMax:20,Charge:7,RangeMinkm:30,RangeMaxkm:40,Chargeunit:4},
    {ChargeId:3,RangeMin:20,RangeMax:50,Charge:6,RangeMinkm:50,RangeMaxkm:50,Chargeunit:4},
    {ChargeId:3,RangeMin:50,RangeMax:100,Charge:5,RangeMinkm:60,RangeMaxkm:60,Chargeunit:3}

]
  return (
    <Modal
      headTxt={'Upload File'}
      width={'60%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Grid container sx={{ display: 'flex', gap: '16px', padding: '12px 8px 4px 8px' }}>
        <Item sx={{ ...sx.itemsx }} className="">
          <Button
            variant="contained"
            id={'add_btn'}
            color="secondary"
            sx={{ width: '100%', fontSize: '16px' }}
            className="receiveitembtn"
            startIcon={<CloudDownloadIcon />}
            onClick={() => {
              updateModal(true, mdt.PickupAndDropoffModal)
            }}
          >
            SAMPLE
          </Button>
        </Item>
        <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
          <FileInput id={''} label={'Chose file'} fileChange={setFileData} accept={".xls, .xlsx"} value={''} />
        </Item>
        <Item sx={{ ...sx.itemsx }} className="">
          <Button
            variant="outlined"
            color="secondary"
            id={'add_btn'}
            sx={{ width: '100%' }}
            className="receiveitembtn"
            startIcon={<CloudUploadIcon style={{ color: theme.palette.secondary.main }} />}
            onClick={() => {
              updateModal(true, mdt.PickupAndDropoffModal)
            }}
          >
            UPLOAD
          </Button>
        </Item>
      </Grid>
      <Grid container sx={{ paddingX: '15px', marginBottom: '10px' }}>
        <TableContainer component={Paper} className="scroll" sx={{ marginY: '5px' }}>
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '& .MuiTableCell-root': {
                padding: '6px 4px !important',
              },
            }}
          >
            <TableHead>
              <TableRow>
                {tableHeader.map((row, index) => {
                  return (
                    <TableCell
                      sx={{
                        ...row.headerSx,
                        backgroundColor: '#DAEDFE',
                        minHeight: '36px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#444',
                      }}
                    >
                      {row.headerName}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableDataDummy.map((val, index) => (
                <TableRow key={`DR-${index}`}>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.ChargeId}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMin}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMax}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMinkm}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMaxkm}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.Charge}</TableCell>
                  <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.Chargeunit}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Modal>
  )
}
export default PIckUpAndDropoffModalKgKm
